/** URL-addressable Photographer workspace navigation. */
export const PHOTOGRAPHER_VIEWS = [
  "overview",
  "events",
  "uploads",
  "gallery",
  "earnings",
];

export function getPhotographerViewFromUrl(location = globalThis.location) {
  if (!location) return "overview";
  const url = new URL(
    location.href || `${location.pathname || "/"}${location.search || ""}`,
    "http://localhost",
  );
  const view = url.searchParams.get("view");
  return PHOTOGRAPHER_VIEWS.includes(view) ? view : "overview";
}

export function navigatePhotographerView(
  view,
  history = globalThis.history,
  location = globalThis.location,
) {
  if (!PHOTOGRAPHER_VIEWS.includes(view) || !history || !location) return false;
  if (getPhotographerViewFromUrl(location) === view) return true;
  const url = new URL(location.href, "http://localhost");
  url.searchParams.set("view", view);
  history.pushState(
    { ...(history.state || {}), view },
    "",
    `${url.pathname}${url.search}${url.hash}`,
  );
  return true;
}

export const AUTH_MODES = ["apply", "signin"];

export function getPhotographerAuthModeFromUrl(location = globalThis.location) {
  if (!location) return "apply";
  const rawHref =
    location.href || `${location.pathname || "/"}${location.search || ""}`;
  const url = new URL(rawHref, "http://localhost");
  const modeParam = (
    url.searchParams.get("mode") ||
    url.searchParams.get("as") ||
    ""
  ).toLowerCase();
  if (modeParam === "signin" || modeParam === "login") return "signin";
  if (modeParam === "apply") return "apply";

  const pathname = String(location.pathname || "").toLowerCase();
  if (pathname.includes("/signin") || pathname.includes("/login"))
    return "signin";
  if (pathname.includes("/apply")) return "apply";

  if (url.searchParams.has("view")) return "signin";

  return "apply";
}

export function navigatePhotographerAuthMode(
  mode,
  history = globalThis.history,
  location = globalThis.location,
) {
  if (!AUTH_MODES.includes(mode) || !history || !location) return false;
  if (getPhotographerAuthModeFromUrl(location) === mode) return true;
  const rawHref =
    location.href || `${location.pathname || "/"}${location.search || ""}`;
  const url = new URL(rawHref, "http://localhost");
  url.pathname = mode === "apply" ? "/apply" : "/signin";
  url.searchParams.delete("mode");
  url.searchParams.delete("as");
  history.pushState(
    { ...(history.state || {}), authMode: mode },
    "",
    `${url.pathname}${url.search}${url.hash}`,
  );
  return true;
}

export function navigatePhotographerWorkspace(
  view = "overview",
  history = globalThis.history,
  location = globalThis.location,
) {
  if (!PHOTOGRAPHER_VIEWS.includes(view) || !history || !location) return false;
  const rawHref =
    location.href || `${location.pathname || "/"}${location.search || ""}`;
  const url = new URL(rawHref, "http://localhost");
  url.pathname = "/";
  url.searchParams.delete("mode");
  url.searchParams.delete("as");
  url.searchParams.set("view", view);
  history.replaceState(
    { ...(history.state || {}), view, workspace: "photographer" },
    "",
    `${url.pathname}${url.search}${url.hash}`,
  );
  return true;
}
